export const FEATURE_FLAG_TOOL_COLOR_CODE = 'tool-color-code';
export const FEATURE_FLAG_TOOL_CLOUDS = 'tools-clouds';
export const FEATURE_FLAG_TOOL_GROW_AI = 'tool-grow-ai';
export const FEATURE_FLAG_TOOL_SAND_THERAPY = 'tools-sand-therapy';
export const FEATURE_FLAG_TIPS = 'tools-clouds-hints';
export const FEATURE_FLAG_PLANS_V2 = 'plans-v2';
export const FEATURE_FLAG_SCREEN_SHARE = 'screen-share';
export const FEATURE_FLAG_MENU_NOTIFICATIONS = 'menu-notifications';
export const FEATURE_FLAG_PROFILE_HOT_OFFER = 'profile-hot-offer';
export const FEATURE_FLAG_ENABLE_PROFILE_CATALOG = 'enable-profile-catalog';
export const FEATURE_FLAG_SUPPORT_AI_BOT = 'support-ai-bot';
